import { createContext } from 'react';
export const DialogContext = /*#__PURE__*/createContext({
  openDialog: () => null,
  closeDialog: () => null
});